function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M42.7339 5.06192L44.4509 8.46769L58.1871 35.7139",
  stroke: "#131416",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.0268 13.5766L50.4326 11.8595C51.3359 11.4041 52.383 11.3262 53.3438 11.6429C54.3045 11.9596 55.1 12.645 55.5554 13.5483L58.9895 20.3598C59.4448 21.2631 59.5228 22.3103 59.2061 23.271C58.8894 24.2317 58.204 25.0272 57.3007 25.4826L53.8949 27.1997",
  stroke: "#131416",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0928 39.2828V60.6835C28.0928 65.1018 31.6745 68.6786 36.0928 68.6786H46.7916C51.2099 68.6786 54.7916 65.1018 54.7916 60.6835V39.2828H28.0928Z",
  fill: "#FA4364"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23 35.2197V54.6164C23 60.1393 27.4772 64.6155 33 64.6155H39.6988C45.2217 64.6155 49.6988 60.1393 49.6988 54.6164V35.2197H23Z",
  stroke: "#131416",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.8071 12.6244L37.8254 18.5293",
  stroke: "#FA4364",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.9097 16.4664L33.6047 25.6519",
  stroke: "#FA4364",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21 16.3719L24.9714 24.1415",
  stroke: "#FA4364",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDeleteIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.c04e0d4e.svg";
export { ForwardRef as ReactComponent };